import { render } from "./HeroiconsOutlineMoon.vue?vue&type=template&id=174f5433"
const script = {}

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMoon.vue"]])

export default __exports__